import { Dispatch, SetStateAction } from 'react';
import { Container, ListItem, ListWrapper } from './SettingsDropdown.styled';
import { useTranslation } from 'react-i18next';
import { useNavigateWithQuery } from 'utils/hooks/useNavigateWithQuery';
import { RoutesConfig } from 'navigation/routes';

interface ISettingsDropdownProps {
  setShowSettingsDropdown: Dispatch<SetStateAction<boolean>>;
}

const SettingsDropdown = ({
  setShowSettingsDropdown,
}: ISettingsDropdownProps) => {
  const { t } = useTranslation();
  const navigateWithQuery = useNavigateWithQuery();

  return (
    <Container>
      <ListWrapper>
        <ListItem
          onClick={() => {
            navigateWithQuery(RoutesConfig.Users.fullPath);
            setShowSettingsDropdown(false);
          }}
        >
          {t('User Management')}
        </ListItem>
        <ListItem
          onClick={() => {
            navigateWithQuery(RoutesConfig.CompanyManagement.fullPath);
            setShowSettingsDropdown(false);
          }}
        >
          {t('Company Management')}
        </ListItem>
      </ListWrapper>
    </Container>
  );
};

export default SettingsDropdown;
